export default __webpack_public_path__ + "static/media/green-light-green.ed0493fe.png";